export const YM_COUNTER_FOR_YM_UID = 45300591;

export const YM_COUNTER_CLIENT_ID = 'YM_COUNTER_CLIENT_ID';
export const ROISTAT_VISIT_ID = 'ROISTAT_VISIT_ID';
